import styled, { css } from 'styled-components';

export const PlanCard = styled.div<{ isHighlighted?: boolean }>`
  min-height: 496px;
  padding: ${({ theme }) => theme.elsie.dimension[40]} ${({ theme }) => theme.elsie.dimension[20]}
    ${({ theme }) => theme.elsie.dimension[20]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.elsie.dimension[20]};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  border: ${({ isHighlighted }) =>
    isHighlighted
      ? css`2px solid ${({ theme }) => theme.elsie.colors.highlight.blueBerry.subtle}`
      : css`1px solid ${({ theme }) => theme.elsie.colors.border.subtle}`};
`;

export const PlanCardMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.elsie.dimension[8]};
  position: relative;
`;

export const PlanCardTag = styled.div`
  position: absolute;
  top: -16px;
  right: 0;
  font-size: 13px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  color: ${({ theme }) => theme.elsie.colors.highlight.blueBerry.accent};
  padding: ${({ theme }) => theme.elsie.dimension[4]} ${({ theme }) => theme.elsie.dimension[8]};
  background-color: ${({ theme }) => theme.elsie.colors.highlight.blueBerry.faint};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.sm};
`;

export const PlanCardIcon = styled.div`
  color: ${({ theme }) => theme.elsie.colors.highlight.blueBerry.accent};
`;

export const PlanCardTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.elsie.colors.content.accent};
  font-size: ${({ theme }) => theme.elsie.fontSize.md};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: -0.32px;
`;

export const PlanCardDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.elsie.colors.content.subtle};
  font-size: 17px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
`;

export const PlanCardButton = styled.button<{ isHighlighted?: boolean }>`
  cursor: pointer;
  font-size: 17px;
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  padding: 9px ${({ theme }) => theme.elsie.dimension[16]};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.md};
  width: fit-content;
  color: ${({ theme, isHighlighted }) =>
    isHighlighted ? theme.elsie.colors.content.onInteractive.accent : theme.elsie.colors.content.onInteractive.soft};
  border: 1px solid ${({ theme, isHighlighted }) => (isHighlighted ? 'transparent' : theme.elsie.colors.border.subtle)};
  background-color: ${({ theme, isHighlighted }) =>
    isHighlighted ? theme.elsie.colors.interactive.accent.default : theme.elsie.colors.surface.faint.default};
  &:hover {
    background-color: ${({ theme, isHighlighted }) =>
      isHighlighted ? theme.elsie.colors.interactive.accent.hovered : theme.elsie.colors.surface.subtle.hovered};
  }
  &:active {
    background-color: ${({ theme, isHighlighted }) =>
      isHighlighted ? theme.elsie.colors.interactive.accent.pressed : theme.elsie.colors.interactive.soft.pressed};
  }
`;

export const PlanCardDivisor = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.elsie.colors.border.subtle};
`;

export const PlanPriceContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const PlanPrice = styled.span`
  color: ${({ theme }) => theme.elsie.colors.content.subtle};
  font-size: 17px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: -0.32px;
`;

export const PlanPriceValue = styled.span`
  color: ${({ theme }) => theme.elsie.colors.content.accent};
  font-size: ${({ theme }) => theme.elsie.fontSize.md};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
`;

export const PlanPriceNote = styled.div`
  color: ${({ theme }) => theme.elsie.colors.content.subtle};
  font-size: 15px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
`;

export const PlanPriceDivisor = styled.div`
  width: 1px;
  height: 46px;
  background-color: ${({ theme }) => theme.elsie.colors.others.divider};
  @media only screen and (min-width: 1320px) {
    height: 32px;
  }
`;
